const formatCurrencyDefaults = {
  currency: 'CHF',
  suffix: '.–',
  shorten: true
}

const formatNumber = (input, precision = 2) => {
  return input.toFixed(precision).replace(/(\d)(?=(\d{3})+(\.|$))/g, "$1'")
}

export const parseCurrency = (input) => {
  input = String(input)
  if (input.match(/^\s*$/)) return NaN

  return Number(input.replace(/[^\-\d.]/g, ''))
}

export const formatCurrency = (input, options = {}) => {
  options = { ...formatCurrencyDefaults, ...options }
  if (!('prefix' in options) && options.currency) options.prefix = `${options.currency} `
  if (!options.prefix) options.prefix = ''
  if (!options.suffix) options.suffix = ''

  input = parseInt(input) || 0

  if (Math.abs(input) >= 10000 && options.shorten) {
    return options.prefix + formatNumber(input / 1000.0, 1) + 'k'
  }

  return options.prefix + formatNumber(input, 0) + options.suffix
}

export const formatPhoneNumber = (input) => {
  input = String(input)
  // Remove all whitespaces and non-digit characters except the +
  input = input.replace(/[^+\d]|\s/g, '')
  // Remove +41 or 0041 at the beginning or any +
  input = input.replace(/^(\+|00)41|\+/g, '')
  // Format phone number according to format +41 00 000 00 00
  input = input.replace(/0*(\d{2})?(\d{3})?(\d{2})?(\d{2})?/, '+41 $1 $2 $3 $4')
  // Reduce duplicate whitespaces
  input = input.replace(/\s+/g, ' ')
  // Remove trailing whitespaces and +41 if that's the only value
  input = input.replace(/\s$|^\s*\+41\s*$/g, '')

  return input
}

export const formatIban = (input) => {
  input = String(input)
  // Remove all non allowed characters
  input = input.replace(/[^A-Za-z0-9]/g, '')

  let country = ''
  let numbers = ''
  let indexOfFirstNumber = input.search(/\d/)

  if (indexOfFirstNumber >= 0) {
    numbers = input.substr(indexOfFirstNumber).toUpperCase()

    // If there aren't at least two letters, use CH as default
    if (indexOfFirstNumber < 2) {
      country = 'CH'
    } else {
      // Otherwise take the last two letters
      country = input
        .substr(0, indexOfFirstNumber)
        .substr(-2)
        .toUpperCase()
    }
  }

  // Concatenate country and number part then split in blocks of four
  // characters, and glue together by space, then remove trailing
  // whitespaces
  return (country + numbers)
    .match(/.{0,4}/g)
    .join(' ')
    .replace(/\s$/g, '')
}

export const formatChUid = (input) => {
  input = String(input)
  // Remove all whitespaces and non-digit characters
  input = input.replace(/[^\d]|\s/g, '')
  // Split in blocks of three characters
  input = input.match(/.{0,3}/g)
  // Glue segments by . character
  input = input.join('.')
  // Remove trailing . characters
  input = input.replace(/\.$/g, '')
  // Prefix input with CHE-
  if (input.length > 0) input = 'CHE-' + input

  return input
}

export const formatCreditCard = (input, options) => {
  input = String(input)
  // Remove all whitespaces, non-digit characters.
  // Allow asterisk, if allowAsterisk is included as option.
  input = input.replace(options?.allowAsterisk ? /[^\d*]|\s/g : /[^\d]|\s/g, '')
  // Split in blocks of four characters
  input = input.match(/.{0,4}/g)
  // Glue segments by " " character
  input = input.join(' ')
  // Remove trailing " " characters
  input = input.replace(/ $/g, '')
  // Remove to many characters
  input = input.substr(0, 19)

  return input
}

export const formatFileSize = (size, decimals = 2) => {
  let divisor = 1
  let type = ''
  const gb = 1024 * 1024 * 1024
  const mb = 1024 * 1024
  const kb = 1024
  if (size >= 0 && size < kb) {
    divisor = 1
    type = 'B'
  } else if (size >= kb && size < mb) {
    divisor = kb
    type = 'KB'
  } else if (size >= mb && size < gb) {
    divisor = mb
    type = 'MB'
  } else {
    divisor = gb
    type = 'GB'
  }

  const result = (size / divisor).toFixed(parseInt(decimals))

  return `${result} ${type}`
}
